import React, { Fragment } from "react";
import {
  Box,
  Grid,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import moment from "moment";
import { FontFamily } from "assets";
import Colors from "assets/Style/Colors";
import { CommaSeparator } from "utils";
import ShippingLanscape from "./shipping_short_landscape.svg";

const ExportVendorPDF = ({
  mode = "landscape",
  vendorFundApprovalDetail,
  currencyExchangeRate,
  tableHead,
  detailList,
  reportType,
  isAgent,
  isBroker,
  isRecoveryAgent,
  isPortAgent,
  dueBreakup,
}) => {
  const currentDate = moment(new Date()).format("DD-MMM-YY HH:mm");
  const totalDue = vendorFundApprovalDetail?.details?.reduce((acc, item) => {
    const funds = item?.funds;
    if (isBroker) {
      return (
        acc +
        parseFloat(funds?.broker_charges ?? 0) -
        parseFloat(funds?.broker_charged_paid ?? 0)
      );
    } else if (isPortAgent) {
      return (
        acc +
        parseFloat(funds?.shifting_charges ?? 0) -
        parseFloat(funds?.shifting_charged_paid ?? 0)
      );
    } else if (isRecoveryAgent) {
      return (
        acc +
        parseFloat(funds?.recovery_charges ?? 0) -
        parseFloat(funds?.recovery_charged_paid ?? 0)
      );
    }
    return acc;
  }, 0);

  return (
    <Box
      sx={{
        minHeight: mode === "landscape" ? "210mm" : "297mm",
        width: "100%",
        overflowX: "auto",
        margin: "5px",
      }}
    >
      {/* Header */}
      <Box component="img" src={ShippingLanscape} width="100%" height="80px" />

      {/* Title and Vendor Info */}
      <Grid container spacing={2} sx={{ background: "#EFF8E7", p: 2 }}>
        <Box className="invoice">
          <Box className="invoice-container">
            <Grid
              container
              spacing={0}
              sx={{
                background: "#EFF8E7",
                display: "flex",
                justifyContent: "center",
                px: 0,
              }}
            >
              <Grid item xs={4}>
                <Box sx={{ marginLeft: "4px", marginTop: "4px" }}>
                  <Typography
                    sx={{
                      borderBottom: "1px solid black",
                      fontWeight: 700,
                      marginBottom: "12px",
                      fontFamily: FontFamily.openSans,
                      fontSize: "14px !important",
                    }}
                  >
                    Vendor Information:-
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "12px !important",
                        fontWeight: 700,
                        width: "80px",
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      Name:
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "12px !important",
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      {vendorFundApprovalDetail?.vendor?.name ?? "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "12px !important",
                        fontWeight: 700,
                        width: "80px",
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      Type:
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "12px !important",
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      {vendorFundApprovalDetail?.vendor?.customerProfile?.type
                        ? vendorFundApprovalDetail?.vendor?.customerProfile
                            ?.type === "Recovery Agent"
                          ? "Recovery & Shifitng Agent"
                          : vendorFundApprovalDetail?.vendor?.customerProfile
                              ?.type
                        : "-" ?? "-"}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "12px !important",
                        fontWeight: 700,
                        width: "80px",
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      Currency:
                    </Typography>
                    <Typography
                      sx={{
                        fontWeight: 700,
                        fontSize: "12px !important",
                        fontFamily: FontFamily.openSans,
                      }}
                    >
                      {vendorFundApprovalDetail?.currency
                        ? vendorFundApprovalDetail?.currency?.toUpperCase()
                        : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid
                item
                xs={4}
                sx={{
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "center",
                }}
              >
                <Typography
                  sx={{
                    fontFamily: FontFamily.openSans,
                    fontSize: "14px !important",
                    fontWeight: 700,
                  }}
                >
                  Vendor Fund Detail
                </Typography>
              </Grid>

              <Grid item xs={4}>
                <Table
                  sx={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "2px",
                  }}
                >
                  <TableBody>
                    <TableRow>
                      {/* Left Column */}
                      <TableCell sx={{ border: "1px solid", padding: "4px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            Ext #
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {vendorFundApprovalDetail?.tt_details
                              ?.external_no ?? "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      {/* Right Column */}
                      <TableCell sx={{ border: "1px solid", padding: "4px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            Exc Rate:
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {vendorFundApprovalDetail?.tt_details?.ex_rate ??
                              "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ border: "1px solid", padding: "4px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            FCY Amount:
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {vendorFundApprovalDetail?.tt_details?.fcy_amount ??
                              "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid", padding: "4px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            LCY Amount:
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {vendorFundApprovalDetail?.tt_details?.lcy_amount ??
                              "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ border: "1px solid", padding: "4px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            TT Charges:
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {vendorFundApprovalDetail?.tt_details?.tt_charges ??
                              "-"}
                          </Typography>
                        </Box>
                      </TableCell>

                      <TableCell sx={{ border: "1px solid", padding: "4px" }}>
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            VAT Charges:
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {vendorFundApprovalDetail?.tt_details
                              ?.vat_charges ?? "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell
                        colSpan={2}
                        sx={{ border: "1px solid", padding: "4px" }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            Total Amount:
                          </Typography>
                          <Typography
                            sx={{
                              fontWeight: 700,
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {vendorFundApprovalDetail?.tt_details
                              ?.total_amount ?? "-"}
                          </Typography>
                        </Box>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
                {!isAgent && (
                  <Box sx={{ display: "flex", mb: 2 }}>
                    <Box
                      sx={{
                        width: "20px",
                        height: "60px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "10px",
                      }}
                    >
                      <Typography
                        sx={{
                          transform: "rotate(-90deg)",
                          transformOrigin: "center center",
                          fontWeight: 700,
                          fontFamily: FontFamily.openSans,
                          fontSize: "10px !important",
                          textAlign: "center",
                          lineHeight: 1,
                          margin: 0,
                          padding: 0,
                        }}
                      >
                        Ageing
                      </Typography>
                    </Box>
                    <Table
                      sx={{
                        width: "95%",
                        borderCollapse: "collapse",
                        marginLeft: "10px",
                      }}
                    >
                      <TableBody>
                        <TableRow>
                          {/* Left Column */}
                          <TableCell
                            sx={{
                              border: "1px solid green",
                              background: Colors.primary,
                              color: Colors.white,
                              padding: "2px",
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                Days
                              </Typography>
                            </Box>
                          </TableCell>
                          {/* Right Column */}
                          <TableCell
                            sx={{
                              border: "1px solid green",
                              background: Colors.primary,
                              color: Colors.white,
                              padding: "2px",
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                Below 15
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid green",
                              background: Colors.primary,
                              color: Colors.white,
                              padding: "2px",
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                Btw 16-30
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid green",
                              background: Colors.primary,
                              color: Colors.white,
                              padding: "2px",
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                Over 30
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{
                              border: "1px solid green",
                              background: Colors.primary,
                              color: Colors.white,
                              padding: "2px",
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                Total
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>

                        <TableRow>
                          {/* Left Column */}
                          <TableCell
                            sx={{
                              border: "1px solid green",
                              background: Colors.primary,
                              color: Colors.white,
                              padding: "2px",
                            }}
                          >
                            <Box
                              sx={{
                                extAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                Amount $
                              </Typography>
                            </Box>
                          </TableCell>

                          {/* Right Column */}
                          <TableCell
                            sx={{ border: "1px solid", padding: "2px" }}
                          >
                            <Box
                              sx={{
                                extAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                {dueBreakup?.below15DaysTotal}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{ border: "1px solid", padding: "2px" }}
                          >
                            <Box
                              sx={{
                                extAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                {dueBreakup?.below16To30DaysTotal}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{ border: "1px solid ", padding: "2px" }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                {dueBreakup?.over30DaysTotal}
                              </Typography>
                            </Box>
                          </TableCell>
                          <TableCell
                            sx={{ border: "1px solid ", padding: "2px" }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                sx={{
                                  fontSize: "10px !important",
                                  fontFamily: FontFamily.openSans,
                                }}
                              >
                                {dueBreakup?.total}
                              </Typography>
                            </Box>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </Box>
                )}
                <Box>
                  <Typography
                    sx={{
                      fontWeight: 700,
                      fontSize: "12px !important",
                      fontFamily: FontFamily.openSans,
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center",
                    }}
                  >
                    Generated on: {currentDate}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Grid>

      {/* Table */}
      <TableContainer component={Paper} sx={{ marginRight: "10px !important" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {tableHead.map((col, idx) => (
                <TableCell
                  colSpan={
                    col === "Menifest #" || col === "CMR #" || col === "VIN#"
                      ? 2
                      : 1
                  }
                  key={idx}
                  sx={{
                    p: 0,
                    px: 2,
                    textAlign: "center",
                    background: Colors.primary,
                    color: Colors.white,
                    fontSize: "8px",
                    fontWeight: 700,
                  }}
                >
                  {col}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {vendorFundApprovalDetail?.details?.length > 0 ? (
              <Fragment>
                {vendorFundApprovalDetail?.details.map((item, index) => {
                  const vehicle = item?.vehicle;
                  const funds = item?.funds;
                  const agentChargesTotal = (
                    parseFloat(funds?.agent_charged_paid || 0) +
                    parseFloat(funds?.border_charged_paid || 0)
                  ).toFixed(2);

                  const totapayable = isBroker
                    ? CommaSeparator(
                        parseFloat(funds?.broker_charged_paid).toFixed(2)
                      )
                    : isAgent
                    ? CommaSeparator(agentChargesTotal)
                    : isPortAgent
                    ? CommaSeparator(funds?.shifting_charged_paid)
                    : 0;
                  return (
                    <>
                      <TableRow
                        key={index}
                        sx={{ bgcolor: index % 2 !== 0 && "#EEFBEE" }}
                      >
                        {/* SR No. */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {index + 1}
                        </TableCell>

                        {/* CMR Date / Pickup Date / MF Date */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {vehicle
                            ? moment(
                                isBroker
                                  ? vehicle.cmr_date
                                  : isRecoveryAgent
                                  ? vehicle.pickup_date
                                  : vehicle.mf_date
                              ).format("DD-MMM-YYYY")
                            : "-"}
                        </TableCell>

                        {/* CMR # or Menifest # */}
                        {(isBroker || isAgent || isPortAgent) && (
                          <TableCell
                            colSpan={2}
                            sx={{
                              fontWeight: 500,
                              px: 2,
                              textAlign: "center",
                              fontSize: "8px",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {isBroker
                              ? vehicle?.cmr_number ?? "-"
                              : vehicle?.manifest_number ?? "-"}
                          </TableCell>
                        )}

                        {/* Model / Make / Color */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {[
                            vehicle?.model?.name,
                            vehicle?.make?.name,
                            vehicle?.color,
                          ]
                            .filter(Boolean)
                            .join(" / ") || "-"}
                        </TableCell>

                        {/* VIN# */}
                        <TableCell
                          colSpan={2}
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {vehicle?.vin ?? "-"}
                        </TableCell>

                        {/* Charges (based on role) */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {isBroker
                            ? parseFloat(funds?.broker_charges)?.toFixed(2) ??
                              "-"
                            : isRecoveryAgent
                            ? vehicle?.pickup_from ?? "-"
                            : isAgent
                            ? parseFloat(funds?.agent_charges)?.toFixed(2) ??
                              "-"
                            : parseFloat(funds?.shifting_charges)?.toFixed(2) ??
                              "-"}
                        </TableCell>

                        {/* Total Payable / Pick To / Border Charges */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {isBroker || isPortAgent
                            ? totapayable ?? "-"
                            : isRecoveryAgent
                            ? vehicle?.destination?.name ?? "-"
                            : isAgent
                            ? funds?.border_charges
                              ? parseFloat(funds?.border_charges)?.toFixed(2)
                              : "-"
                            : "-" ?? "-"}
                        </TableCell>

                        {/* Paid / Applied or Recovery or Total Payable */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {isBroker || (!isAgent && !isRecoveryAgent)
                            ? `${
                                parseFloat(item?.applied_amount)?.toFixed(2) ??
                                "0.00"
                              } `
                            : isRecoveryAgent
                            ? parseFloat(funds?.recovery_charges)?.toFixed(2) ??
                              "-"
                            : totapayable ?? "-"}
                        </TableCell>

                        {/* Balance or Shifting or Paid Date */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {isBroker
                            ? parseFloat(
                                funds?.broker_charges -
                                  funds?.broker_charged_paid
                              )?.toFixed(2) ?? "-"
                            : isRecoveryAgent
                            ? parseFloat(funds?.recovery_charges)?.toFixed(2) ??
                              "-"
                            : isAgent
                            ? item?.created_at
                              ? moment(item?.created_at).format("DD-MMM-YYYY")
                              : "-"
                            : parseFloat(
                                funds?.shifting_charges -
                                  funds?.shifting_charged_paid
                              )?.toFixed(2) ?? "-"}
                        </TableCell>

                        {/* Paid / Applied Date / Total / Past Due */}
                        <TableCell
                          sx={{
                            fontWeight: 500,
                            px: 2,
                            textAlign: "center",
                            fontSize: "8px",
                            fontFamily: FontFamily.openSans,
                          }}
                        >
                          {isBroker
                            ? item?.created_at
                              ? moment(item?.created_at).format("DD-MMM-YYYY")
                              : "-"
                            : isRecoveryAgent
                            ? parseFloat(item?.applied_amount)?.toFixed(2) ??
                              "-"
                            : isAgent
                            ? moment().diff(vehicle?.manifest_date, "days") ??
                              "-"
                            : item?.created_at
                            ? moment(item?.created_at).format("DD-MMM-YYYY")
                            : "-"}
                        </TableCell>

                        {/* Extra column: Past Due for Broker/Port Agent */}
                        {(isBroker || isPortAgent) && (
                          <TableCell
                            sx={{
                              fontWeight: 500,
                              px: 2,
                              textAlign: "center",
                              fontSize: "8px",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {isPortAgent
                              ? moment().diff(vehicle?.manifest_date, "days") ||
                                "-"
                              : isBroker
                              ? moment().diff(vehicle?.cmr_date, "days") || "-"
                              : "-"}{" "}
                          </TableCell>
                        )}

                        {/* Extra columns for Recovery Agent */}
                        {isRecoveryAgent && (
                          <>
                            <TableCell
                              sx={{
                                fontWeight: 500,
                                px: 2,
                                textAlign: "center",
                                fontSize: "8px",
                                fontFamily: FontFamily.openSans,
                              }}
                            >
                              {`${
                                parseFloat(
                                  funds?.recovery_charges -
                                    funds?.recovery_charged_paid
                                )?.toFixed(2) ?? "0.00"
                              }`}
                            </TableCell>

                            <TableCell
                              sx={{
                                fontWeight: 500,
                                px: 2,
                                textAlign: "center",
                                fontSize: "8px",
                                fontFamily: FontFamily.openSans,
                              }}
                            >
                              {item?.created_at
                                ? moment(item?.created_at).format("DD-MMM-YYYY")
                                : "-"}
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: 500,
                                px: 2,
                                textAlign: "center",
                                fontSize: "8px",
                                fontFamily: FontFamily.openSans,
                              }}
                            >
                              {moment().diff(
                                vehicle?.recovery?.update_recovery_date,
                                "days"
                              ) || "-"}{" "}
                            </TableCell>
                          </>
                        )}
                      </TableRow>
                      {!isAgent && (
                        <TableRow>
                          <TableCell
                            colSpan={
                              isRecoveryAgent
                                ? tableHead?.length - 2
                                : tableHead?.length - 1
                            }
                            sx={{
                              fontWeight: "bold !important",
                              px: 2,
                              textAlign: "center",
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            Total Due
                          </TableCell>
                          <TableCell
                            colSpan={1}
                            sx={{
                              fontWeight: "bold !important",
                              px: 2,
                              textAlign: "center",
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          >
                            {CommaSeparator(parseFloat(totalDue).toFixed(2))}
                          </TableCell>
                          <TableCell
                            colSpan={2}
                            sx={{
                              fontWeight: "bold !important",
                              px: 2,
                              textAlign: "center",
                              fontSize: "10px !important",
                              fontFamily: FontFamily.openSans,
                            }}
                          ></TableCell>
                        </TableRow>
                      )}
                    </>
                  );
                })}
              </Fragment>
            ) : (
              <TableRow>
                <TableCell
                  colSpan={tableHead.length + 1}
                  align="center"
                  sx={{ fontWeight: 600 }}
                >
                  No Data Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Box
        sx={{
          background: "#EFF8E7",
          p: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Grid
          container
          spacing={1}
          sx={{
            display: "flex",
            justifyContent: "space-around",
            alignItems: "center",
          }}
        >
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold !important",
                  px: 2,
                  fontSize: "10px !important",
                  fontFamily: FontFamily.openSans,
                }}
              >
                Wallet Balance Receivable
              </Typography>
              <Box
                sx={{
                  fontWeight: "bold !important",
                  px: 2,
                  fontSize: "10px !important",
                  textAlign: "center",
                  py: 1,
                  width: "130px",
                  bgcolor: Colors.flashWhite,
                  border: "1px solid #B2B5BA",
                  borderRadius: "4px",
                }}
              >
                <Typography variant="body2" sx={{ color: Colors.smokeyGrey }}>
                  0
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold !important",
                  px: 2,
                  fontSize: "10px !important",
                  fontFamily: FontFamily.openSans,
                }}
              >
                Vendor Un-Applied Funds
              </Typography>
              <Box
                sx={{
                  fontWeight: "bold !important",
                  px: 2,
                  fontSize: "10px !important",
                  textAlign: "center",
                  py: 1,
                  width: "130px",
                  bgcolor: Colors.flashWhite,
                  border: "1px solid #B2B5BA",
                  borderRadius: "4px",
                }}
              >
                <Typography variant="body2" sx={{ color: Colors.smokeyGrey }}>
                  0
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Box
              sx={{
                display: "flex",
                gap: "10px",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold !important",
                  px: 2,
                  fontSize: "10px !important",
                  fontFamily: FontFamily.openSans,
                }}
              >
                Net Due / Receivable
              </Typography>
              <Box
                sx={{
                  fontWeight: "bold !important",
                  px: 2,
                  fontSize: "10px !important",
                  textAlign: "center",
                  py: 1,
                  width: "130px",
                  bgcolor: Colors.flashWhite,
                  border: "1px solid #B2B5BA",
                  borderRadius: "4px",
                }}
              >
                <Typography variant="body2" sx={{ color: Colors.smokeyGrey }}>
                  0
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
      {/* Footer */}
    </Box>
  );
};

export default ExportVendorPDF;
